package com.taager.dukan.customer.domain.entity

data class Province(
    val id: String,
    val name: String,
    val cities: List<City>,
)
